module.exports = __webpack_public_path__ + "img/avatar1.77bfc63b.svg";